import { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { TextField } from "@rmwc/textfield";
import { Checkbox } from "@rmwc/checkbox";
import { loginRememberMeChange, onLoginTextFiledChangeValue, onSubmitLogin } from "../../action/manufacturers_auth/login.action.js";
import { getSelectedTabstate } from "../../action/index.js";

const BeforeLogedIn = () => {
	const dispatch = useDispatch();
	const { const_var, params } = useSelector((state) => state.reducer);
	const { alertCheckLoginAPI, alertForLoginAPI, alertForLoginAPIMSG, displayerrorMessage, loginRememberMe } = useSelector((state) => state.loginReducer);
	const { crmSetting, showReportLoading, loginSession, resetpasswordcrm } = const_var;
	// const [showModal, setShowModal] = useState(props.alertCheckLoginAPI ?? false);
	// const showModalHandler = () => setShowModal(true);
	// const closeModal = () => setShowModal(false);

	const setCursorEvent = () => {
		const_var.hideZipCodeField = false;
		const_var.zipManufErrMsg = "";

		if (const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true) {
			const inputElements = [...document.querySelectorAll("input.zipInput")];
			inputElements != undefined &&
				inputElements.forEach((ele) => {
					ele.value = "";
				});
			const_var.resetVal = false;
			setTimeout(() => {
				window.document.getElementById("zip1").focus();
			}, 1000);
		}
	};

	let userObj = "";
	if (localStorage.getItem("RememberuserData") != undefined) {
		userObj = JSON.parse(localStorage.getItem("RememberuserData"));
		const decryptedpsw = userObj.password;
		userObj.password = decryptedpsw;
	}

	let alertMessage = "";
	if (alertForLoginAPI == "onSubmitLoginApiErrorhandling") {
		alertMessage = alertForLoginAPIMSG;
	}

	const isZipCodeActive = crmSetting.is_zipcode_screen != undefined && crmSetting.is_zipcode_screen == true ? true : false;

	let logoIMG = window.location.origin + "/logo.svg";
	if (loginSession == true && crmSetting.api_token == "7KJeHld8lthhZRr0qzJEjYfnbjmXhXiKSGa73bv1XqENGNIthoKdbT4gIznBTV7i") {
		logoIMG = "https://crm.senseicrm.com/mfg_logo.svg";
	} else {
		logoIMG = window.location.origin + "/logo.svg";
	}

	let bottomHighlightedText = "Sensei 3D ";
	let bottomText = "sets the standard for how dreaming and designing metal buildings should feel - intuitive, full of options, and realistic. ";
	if (crmSetting.main_domain_url != undefined && crmSetting.main_domain_url == "safeguardmetalbuildings.com") {
		bottomHighlightedText = "";
		bottomText = "A premier supplier of Carports, Garages, Metal Barns, and Steel Buildings";
	}
	if (crmSetting.main_domain_url != undefined && crmSetting.main_domain_url == "aametalbuildings.com") {
		bottomHighlightedText = "";
		bottomText = "America" + "'s" + "#1 Dealer of Custom Metal Buildings. YOU WANT IT. WE GOT IT";
	}
	if (crmSetting.main_domain_url != undefined && crmSetting.main_domain_url == "custombuiltstructures.com") {
		bottomHighlightedText = "";
		bottomText = "Your Premier Steel Building Choice";
	}
	if (crmSetting.main_domain_url != undefined && crmSetting.main_domain_url == "americanmetalbuildings.com") {
		bottomHighlightedText = "";
		bottomText = "American Metal Buildings offers extremely versatile metal buildings and steel structures across the USA";
	}
	if (crmSetting.main_domain_url != undefined && crmSetting.main_domain_url == "eaglebuildings.com") {
		bottomHighlightedText = "";
		bottomText = "Our mission is to provide you with seamless experience, ensuring that every aspect of your metal building project is handled with the utmost care and precision";
	}
	if (crmSetting.main_domain_url != undefined && crmSetting.main_domain_url == "fivestarmetalbuildings.com") {
		bottomHighlightedText = "";
		bottomText = "We Build Great Buildings";
	}

	const bgImage =
		crmSetting.main_domain_url !== undefined && crmSetting.main_domain_url === "garagebuildings.com"
			? "https://cdn.sensei3d.com/static/media/garagebuildings.d1a92a99.png"
			: crmSetting.state_screen_bg_image_type_two !== undefined
				? "https://cdn.sensei3d.com/static/media/img-a.7d466d21.png"
				: crmSetting.main_domain_url == "eaglebuildings.com"
					? "https://cdn.sensei3d.com/static/media/eaglebuildings_img.f6c182d3.png"
					: crmSetting.main_domain_url !== undefined && crmSetting.main_domain_url == "custombuiltstructures.com"
						? "https://cdn.sensei3d.com/static/media/CustomBuilt_bg.359c5d7e.png"
						: crmSetting.main_domain_url !== undefined && crmSetting.main_domain_url == "fivestarmetalbuildings.com"
							? "https://cdn.sensei3d.com/static/media/fivestarmetalbuildings_bg.359c5d7e.png"
							: crmSetting.main_domain_url == "carportx.com"
								? "https://cdn.sensei3d.com/static/media/carportx_img-a.7d466d21.png"
								: "https://cdn.sensei3d.com/static/media/new-bg.14dd4039.png";

	return (
		<>
			<div className="state-wrapper" style={{ backgroundImage: `url(${bgImage})` }}>
				<form
					className={"container" + (showReportLoading == true ? " form-submiting" : "")}
					onSubmit={(e) => {
						alertCheckLoginAPI != true ? dispatch(onSubmitLogin(e)) : e.preventDefault();
					}}
				>
					<div className="state-all-content">
						<div className="back-to-crm-state-wrapper back-to-zip">
							<a
								href
								onClick={() => (isZipCodeActive ? (setCursorEvent(), dispatch(getSelectedTabstate("statechange", false, true))) : dispatch(getSelectedTabstate("statechange")))}
								className="back-to-crm-state"
							>
								<span className="icon-arrow-s2 icon"></span>
								<span className="text">{isZipCodeActive == true ? "BACK TO ZIP CODE" : "Go Back"}</span>
							</a>
						</div>

						<div className="state-change-top">
							<div className="state-text-content">
								<div className={"state-text-logo" + (crmSetting.main_domain_url == "americansteelinc.com" ? " state-text-logo-inc" : "")}>
									<img src={logoIMG} className="mfg_zip_big_logo" />
								</div>

								<div className="span-1">
									{crmSetting.parent_api_token == "Fq6Meq4bloS4c7Pqj7OuVNHfiPhWnuesTwy3KiuFNCJ2cyu3WKIGEFqc74qsprei" ||
									crmSetting.parent_api_token == "P0pjF0vzahFWP8DTFzQulTkOFi5b2cpoeNrLSxIMXxgMRe0fpAYKRpFRLCPvC9ke"
										? "Dealer Login"
										: "Sales Login"}
								</div>

								<div className="span-3">Let's get started.</div>
							</div>

							<div
								className={
									"floating-lbl-nw " +
									(displayerrorMessage.username == "" || displayerrorMessage.username == undefined
										? "floating-label-input mdc-field-label-md mb-4"
										: "floating-label-input mdc-field-label-md invalid-input mb-4")
								}
							>
								<TextField
									label="Username"
									name="username"
									value={userObj != undefined ? userObj.username : ""}
									id="username"
									onChange={(e) => dispatch(onLoginTextFiledChangeValue(e, "username", "Username"))}
									onBlur={(e) => dispatch(onLoginTextFiledChangeValue(e, "username", "Username"))}
									autoFocus
								/>
								<span className="error-icon icon-info-ico"></span>
								<div className="errorMessage" id="usernameErrorMessage">
									{displayerrorMessage.username}
								</div>
							</div>

							<div
								className={
									"floating-lbl-nw " +
									(displayerrorMessage.password == "" || displayerrorMessage.password == undefined
										? "floating-label-input mdc-field-label-md mb-4"
										: "floating-label-input mdc-field-label-md invalid-input mb-4")
								}
							>
								<TextField
									label="Password"
									name="password"
									type="Password"
									value={userObj != undefined ? userObj.password : ""}
									onChange={(e) => dispatch(onLoginTextFiledChangeValue(e, "password", "Password"))}
									onBlur={(e) => dispatch(onLoginTextFiledChangeValue(e, "password", "Password"))}
								/>
								<span className="error-icon icon-info-ico"></span>
								<div className="errorMessage" id="passwordErrorMessage">
									{displayerrorMessage.password}
								</div>
							</div>

							{alertCheckLoginAPI == true && (
								<div className="col-12">
									<p className="loginerror">{alertMessage}</p>
								</div>
							)}

							<div className="d-flex justify-content-between">
								<div className="checkbox">
									<Checkbox
										className="secondary"
										ripple="RipplePropF"
										label="Remember Me"
										name="remember"
										checked={userObj.remember != undefined ? userObj.remember : loginRememberMe}
										onChange={() => dispatch(loginRememberMeChange())}
									/>
								</div>
								{resetpasswordcrm == true && (
									<div className="reset-crm-pw">
										<a target="_blank" href="https://crm.senseicrm.com/update_password" className="anchor-primary">
											Reset Password?
										</a>
									</div>
								)}
							</div>

							<div className="change-state-cta mt-4 pt-2">
								<button className="btn-solid btn-block" onClick={() => (isZipCodeActive == true ? setCursorEvent() : null)}>
									<span className="text">LogIn</span>
									<span className="saving-effect">
										<span></span>
										<span></span>
										<span></span>
									</span>
								</button>
							</div>
						</div>

						<div className="change-state-footer">
							{crmSetting.main_domain_url != undefined && crmSetting.main_domain_url == "steelbuildingsandstructures.com" ? (
								<div className="span-text btm-bold-text">THE COMPANY THAT BUILDS WITH PRIDE</div>
							) : (
								<div className="span-text">
									<span className="highlighted-text text-bold">{bottomHighlightedText}</span>
									{bottomText}
									{params.m_s_n == 13 || crmSetting.main_domain_url == "tubularbuildingsystems.com" ? (
										<>
											<label style={{ background: "#ffc2003b", padding: "5px", marginTop: "5px", borderRadius: "2px", fontStyle: "italic" }}>
												*Binding quotes and sales contracts are generated through contact with one of our sales representatives.
											</label>
										</>
									) : (
										""
									)}
								</div>
							)}
						</div>
					</div>
				</form>
			</div>
		</>
	);
};


export default BeforeLogedIn;

